import { render, staticRenderFns } from "./DeleteOutput.vue?vue&type=template&id=080c7da0&scoped=true&"
import script from "./DeleteOutput.vue?vue&type=script&lang=ts&"
export * from "./DeleteOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c7da0",
  null
  
)

export default component.exports